<template>
  <div class="label-custom">
     <div v-if="type == 'premium'" class="label-premium">
      <div class="wrapper">
        <div class="label" :style="getFontColor(color)">{{label}}</div>
        <div class="icon"><img  class="image" src="/img/icons/ic-premium.png" alt=""></div>
      </div>
    </div>
    <div v-else class="status-label">
      <div class="label" :style="getColor(color)">
        {{label}} 
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'adx-status-label-custom',
  components: {

  },
  props: {
    label: {
      required: false
    },
    color:{
      required: false
    },
    type: {
      required: false,
      default: null
    }
  },
  data() {
    return {

    }
  },
  computed: {

  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {

  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    getColor(color){
      return {
        "background-color": color
      }
    },
    getFontColor(color){
      return {
        "color": color
      }
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>